import { Routes } from '@angular/router';

/**
 * GAP-FE-M002 · Production replacement for dev-routes.ts.
 *
 * The production / staging Angular CLI configurations apply
 * `fileReplacements` to swap `src/app/dev-routes.ts` for THIS file
 * at build time. The empty array means the `import()` references
 * to `test-backend` and `style-guide` components never appear in
 * the production source, so tree-shake drops those lazy chunks.
 *
 * If you need to add a new dev-only route, put it in
 * `dev-routes.ts`; the prod file MUST stay empty.
 */
export const devRoutes: Routes = [];
